import React from 'react'
import NotePreviewModal from './note-preview-modal'
import SendNoteModal from './send-note-modal'

function NoteModalsWrapper(props) {
  const { note, onClose } = props
  const [showPreview, setShowPreview] = React.useState(Boolean(note))

  if (showPreview)
    return (
      <NotePreviewModal
        note={note}
        onClose={onClose}
        toggleEdit={() => setShowPreview(false)}
      />
    )

  return <SendNoteModal {...props} />
}

export default NoteModalsWrapper
